import { render, staticRenderFns } from "./MonumentsBelfortMontbeliard.vue?vue&type=template&id=fe7cbbc8&"
import script from "./MonumentsBelfortMontbeliard.vue?vue&type=script&lang=js&"
export * from "./MonumentsBelfortMontbeliard.vue?vue&type=script&lang=js&"
import style0 from "./MonumentsBelfortMontbeliard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports